var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1BondingBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 142,
    viewBox: "0 0 563 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_25696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.405 30.0601L5.63496 41.3901L0.0849609 32.1001L25.285 17.6901C26.805 16.8101 28.095 16.5801 29.605 16.5801C33.305 16.5801 36.295 19.5801 36.295 23.2701V103.96L25.375 103.94L25.405 30.0601Z",
    fill: "#4D7CBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.255 14.79C216.255 14.79 168.555 42.12 168.325 42.26C152.125 52.03 146.605 71.91 156.255 88.14C159.885 94.25 164.295 98.6501 170.465 101.87L182.865 94.7501C175.475 93.5601 169.475 89.6201 165.645 82.8101C158.695 70.4201 163.845 56.1301 175.625 49.4901C175.945 49.3101 176.265 49.1701 176.585 49.0001C176.585 49.0001 175.525 49.5601 174.915 49.9301C174.305 50.3001 212.095 28.6301 212.095 28.6301L216.255 14.79Z",
    fill: "url(#paint0_linear_1006_25696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.854 127.21C156.854 127.21 204.555 99.8801 204.785 99.7401C220.985 89.9801 226.504 70.0901 216.854 53.8601C213.214 47.7401 208.805 43.3401 202.625 40.1201L190.245 47.2501C197.635 48.4401 203.645 52.3801 207.465 59.1901C214.415 71.5801 209.264 85.8701 197.484 92.5101C197.164 92.6901 196.845 92.8301 196.525 93.0001C196.525 93.0001 197.585 92.4401 198.195 92.0701C198.805 91.7001 161.014 113.37 161.014 113.37L156.854 127.21Z",
    fill: "url(#paint1_linear_1006_25696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.245 27.9297C402.674 27.9297 406.265 24.339 406.265 19.9097C406.265 15.4803 402.674 11.8896 398.245 11.8896C393.815 11.8896 390.225 15.4803 390.225 19.9097C390.225 24.339 393.815 27.9297 398.245 27.9297Z",
    fill: "#183E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.984 38.2896L403.704 38.3396V104.02L392.984 103.97V38.2896Z",
    fill: "#183E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.314 68.1897C231.314 50.3897 246.204 36.1697 263.454 36.1397C284.244 36.1197 295.594 53.4397 295.594 68.1897L295.394 103.86H284.724L284.874 68.1897C284.874 56.7897 275.994 46.9397 263.384 46.8797C250.524 46.9897 242.084 57.3297 242.044 68.1897L242.074 104.09H231.404L231.314 68.1897Z",
    fill: "#183E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.434 47.7701C559.364 53.68 562.404 60.39 563.004 68.54V113.29C563.014 126.89 558.094 134.69 551.114 141.51L536.104 141.57C538.434 140.03 543.864 134.84 546.194 131.54C547.484 129.66 552.084 125.27 552.334 111.73L552.274 92.9301C547.304 100.95 538.234 105.72 528.174 105.72C509.964 105.72 493.444 90.11 493.444 70.83C493.444 51.82 510.034 36.2301 528.214 36.0601C536.334 36.1901 546.344 38.5 554.434 47.7701ZM504.254 70.86C504.284 84.89 515.374 94.8901 528.184 94.9901C541.154 95.0901 552.274 84.4901 552.274 70.7401C552.274 56.9901 540.754 46.7801 528.214 46.7801C515.134 46.7701 504.224 57.28 504.254 70.86Z",
    fill: "#183E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.015 67.9196C419.015 50.1196 433.905 35.8996 451.155 35.8696C471.945 35.8496 483.295 53.1696 483.295 67.9196L483.105 103.59H472.435L472.585 67.9196C472.585 56.5196 463.705 46.6696 451.095 46.6096C438.235 46.7196 429.795 57.0596 429.755 67.9196L429.785 103.82H419.115L419.015 67.9196Z",
    fill: "#183E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.815 105.78C323.645 105.62 307.045 90.03 307.045 71.01C307.045 51.73 323.575 36.12 341.775 36.12C351.835 36.12 360.905 40.89 365.875 48.91L365.935 30.11C365.675 16.58 361.085 12.18 359.795 10.3C357.465 7.00002 352.035 1.81002 349.705 0.27002L364.715 0.330017C371.705 7.15002 376.615 14.95 376.605 28.55V73.3C376.005 81.45 372.955 88.17 368.035 94.07C359.945 103.34 349.935 105.65 341.815 105.78ZM341.815 95.07C354.355 95.07 365.875 84.86 365.875 71.11C365.875 57.35 354.745 46.76 341.785 46.86C328.975 46.96 317.885 56.96 317.855 70.99C317.815 84.56 328.735 95.07 341.815 95.07Z",
    fill: "#183E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2243 94.1398C77.2943 88.2298 74.2543 81.5199 73.6543 73.3699V28.6198C73.6443 15.0198 78.5643 7.21984 85.5443 0.399841L100.554 0.339844C98.2243 1.87984 92.7943 7.06984 90.4643 10.3698C89.1743 12.2498 84.5743 16.6399 84.3243 30.1799L84.3843 48.9798C89.3543 40.9598 98.4343 36.3298 108.484 36.1898C126.844 35.9398 142.954 51.4898 143.214 71.0798C143.314 90.0398 127.024 105.78 108.444 105.85C100.324 105.71 90.3043 103.4 82.2243 94.1398ZM132.404 71.0398C132.374 57.0098 121.284 47.0098 108.474 46.9098C95.5043 46.8098 84.3843 57.4098 84.3843 71.1598C84.3843 84.9198 95.9043 95.1199 108.444 95.1199C121.524 95.1399 132.434 84.6298 132.404 71.0398Z",
    fill: "#4D7CBE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1006_25696",
    x1: 152.564,
    y1: 81.7029,
    x2: 229.381,
    y2: 37.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7001,
    stopColor: "#183E71",
    stopOpacity: 0.3533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7037,
    stopColor: "#183E71",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7253,
    stopColor: "#183E71",
    stopOpacity: 0.3191
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9484,
    stopColor: "#183E71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1006_25696",
    x1: 220.541,
    y1: 60.2974,
    x2: 143.723,
    y2: 104.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D7CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7281,
    stopColor: "#4D7CBE",
    stopOpacity: 0.3533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7318,
    stopColor: "#4D7CBE",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7533,
    stopColor: "#4D7CBE",
    stopOpacity: 0.3191
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#4D7CBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_25696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 563,
    height: 142,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1BondingBlue);
export default __webpack_public_path__ + "static/media/1bonding_blue.281d92b16dce1f5deaaecec7e5e5061f.svg";
export { ForwardRef as ReactComponent };